import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';

import documentTypeService from '../../../service/newDocumentType.service';
import { DeleteDialogUI, FormErrorUI, FormLabelUI, InputUI, TabsUI } from '../../Interface';
import { getDocumentDateLabels } from '../../../utils/documentDateLabels';
import DocumentTypeAttachmentTab from './DocumentTypeAttachmentTab';

const DocumentTypeTabs = (props) => {
  const { values, setFieldValue, errors } = useFormikContext();
  const defaultDateLabels = getDocumentDateLabels();
  const { user, selectedValues, setSelectedValues, disabled, setRefetchTable, languageOptions } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [removeElement, setRemoveElement] = useState(null);
  const [deleteDialog, setDeletDialog] = useState(false);

  const handleDelete = (data) => {
    setRemoveElement(data.id);
    setDeletDialog(true);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
    setRefetchTable(true);
  };

  const handleRemoveElement = () => {
    documentTypeService.deleteFile(removeElement, user.userId).then((data) => {
      setRefetchTable(true);
      setSelectedValues((prev) => ({ ...prev, printReport: data }));
      setFieldValue(
        'printReport',
        (data ?? []).map((row) => ({
          ...row,
          langCode: row.langCode ?? row.language?.code ?? null,
          isDraft: false,
        }))
      );
      hideDeleteDialog();
    });
  };

  const tabs = [
    {
      id: 0,
      name: 'Riport mellékletek',
      content: (
        <DocumentTypeAttachmentTab
          attachmentRows={values.printReport ?? []}
          setAttachmentRows={(nextValue) => {
            const nextRows = typeof nextValue === 'function' ? nextValue(values.printReport ?? []) : nextValue;
            setFieldValue('printReport', nextRows);
          }}
          disabled={disabled}
          handleDelete={handleDelete}
          languageOptions={languageOptions}
        />
      ),
    },
    {
      id: 1,
      name: 'Dátumok elnevezése',
      content: (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mx-4 mb-5">
          {Object.entries(defaultDateLabels).map(([field, label]) => (
            <Field
              key={field}
              name={`${field}Label`}
              as={InputUI}
              value={values[`${field}Label`] ?? ''}
              onChange={(event) => setFieldValue(`${field}Label`, event.target.value || null)}
              label={<FormLabelUI text={label} />}
              placeholder={label}
              helperText={<FormErrorUI message={errors[`${field}Label`]} />}
              inputProps={{ maxLength: 100 }}
              disabled={disabled}
              fullWidth
              variant="standard"
              InputLabelProps={{ shrink: true }}
            />
          ))}
        </div>
      ),
    },
  ];

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={setActiveTab}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI handleRemoveElement={handleRemoveElement} show={deleteDialog} onHide={hideDeleteDialog} />
    </div>
  );
};

export default DocumentTypeTabs;
